import { SvgIconType } from './svg.interface';

const Check: SvgIconType = ({
  width = 12,
  height = 12,
  color = '#228403',
  className = ''
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.97308 9.90981L0.21967 6.19095C-0.0732233 5.89561 -0.0732233 5.41677 0.21967 5.12143C0.512563 4.82608 0.987437 4.82608 1.28033 5.12143L4.50051 8.2901L10.7167 2.09651C11.0095 1.80116 11.4844 1.80116 11.7773 2.09651C12.0702 2.39185 12.0702 2.87069 11.7773 3.16603L5.02456 9.90635C4.73368 10.1965 4.26583 10.1981 3.97308 9.90981Z"
      fill={color}
    />
  </svg>
);

export default Check;
